import createSetHeldReservation from './setHeldReservation';
import { heldReservationVar } from '../reactiveVariables';

const setHeldReservation = createSetHeldReservation(heldReservationVar);

export default setHeldReservation;
